// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * Static site definitions used as a fallback in development when the
 * OMS API is not available. IDs match the OMS mock in oms-api.yaml.
 */
export interface StaticSite {
  id: string;
  siteKey: string;
  orgId: string;
  orgKey: string;
  regionKey: string;
  label: string;
  location: string;
  status: string;
  capacity: string;
}

export const STATIC_SITES: StaticSite[] = [
  {
    id: 'simple-dc-001',
    siteKey: 'hq-dc',
    orgId: '018f7d13-7165-7f84-90f8-4fba9c0f245f',
    orgKey: 'helios-research',
    regionKey: 'california',
    label: 'Headquarters Data Center',
    location: 'San Francisco, CA',
    status: 'online',
    capacity: '1,500 kW',
  },
  {
    id: 'GA-10',
    siteKey: 'ga-10',
    orgId: '018f7d13-7165-7f84-90f8-4fba9c0f245f',
    orgKey: 'helios-research',
    regionKey: 'georgia',
    label: 'Prime Edge Data Centers GA-10 Alterations — Marietta, GA',
    location: 'Marietta, GA',
    status: 'online',
    capacity: '1,500 kW',
  },
];
